<div class="wrapper" *transloco="let convert;">
  <label for="added-by">{{ convert('vehicles.bidListFilter.bidListUserDropdown.labelAddedBy') }}</label>
  <div class="app-select__wrap">
  <trap-focus [enableFocusTrap]="classPop.isOpen" [focusOnFirstElem]="true" [enableArrowKeys]="true">
    <i class="allycon-glyph-chevron-down app-select__icon text-primary"></i>
    <button
      data-testid="bidlist-user-dropdown-toggle-button"
      name="added-by"
      class="btn btn-light dropdown-toggle app-select__select"
      type="button"
      [popover]="classTemplate"
      #classPop="bs-popover"
      placement="bottom"
      (keydown.escape)="classPop.hide()"
      [outsideClick]="true"
      (onShown)="isPopoverOpen = true"
      (onHidden)="isPopoverOpen = false"
      [attr.aria-expanded]="isPopoverOpen"
      aria-haspopup="true"
    >
      <span> {{defaultUser.userName}} </span>
    </button>

    <ng-template id="classTemplate" #classTemplate>
      <user-popover data-testid="bidlist-user-dropdown-popover"
        [userValues]="listOfUsers"
        (closePop)="classPop.hide()"
        (userSelected)="filterBySelectedUser($event)"
      ></user-popover>
    </ng-template>
  </trap-focus>
</div>
</div>
